const registry = new Map();

/**
 * Register custom intro/success screens for a DataSync app.
 *
 * Add registrations to `ui-universal-auth/static-1.9307/js/dataSyncRegistrations.ts`, which
 * is called once at app bootstrap via `initializeDataSyncRegistrations()`. Register
 * at init time, NOT inside a React component. Registration is stored in a
 * module-level singleton, so it persists for the full page session.
 *
 * @example
 * // In ui-universal-auth/static-1.9307/js/dataSyncRegistrations.ts
 * import { getQboAppId } from './constants/appIds';
 * import { QboIntroScreen } from './screens/qbo/QboIntroScreen';
 * import { QboSuccessScreen } from './screens/qbo/QboSuccessScreen';
 *
 * registerDataSyncScreens(getQboAppId(), {
 *   introScreen: (props) => <QboIntroScreen {...props} />,
 *   successScreen: (props) => <QboSuccessScreen {...props} />,
 * });
 */
export function registerDataSyncScreens(appId, overrides) {
  registry.set(appId, overrides);
}
export function unregisterDataSyncScreens(appId) {
  registry.delete(appId);
}
export function getDataSyncScreens(appId) {
  return registry.get(appId);
}